import clsx from "clsx";
import React from "react";

interface Props {
  children: React.ReactNode,
  className?: string,
}

const BlockQuote: React.FC<Props> = (
  {
    children,
    className = null,
  }
) => {

  return (
    <blockquote
      className={clsx(
        "border-l border-solid dark:border-white pl-6 py-4 italic",
      className
        )}
      >
      {children}
    </blockquote>
  );
};

export default BlockQuote;